import { render, staticRenderFns } from "./UpLoad.vue?vue&type=template&id=f7537ac4&scoped=true&"
import script from "./UpLoad.vue?vue&type=script&lang=js&"
export * from "./UpLoad.vue?vue&type=script&lang=js&"
import style0 from "./UpLoad.vue?vue&type=style&index=0&id=f7537ac4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7537ac4",
  null
  
)

export default component.exports